// @ts-nocheck
import React from 'react';
import {
  Box,
  IconButton,
  DialogContent,
  Dialog,
  DialogTitle,
  Typography,
  Grid,
} from '@mui/material';
import SolyticsTypography from '../../../../package/components/SolyticsTypography';
import { ReactComponent as CloseIcon } from '../../../../assets/Icons/lucideIcons/x.svg';
import PropTypes from 'prop-types';

import useModalDisclosure from '../../../../hooks/useModalDisclosure';
import useTextOverflow from '../../../../hooks/useTextOverFlow';

const ViewTextFieldExtended = ({ value, attribute }) => {
  const { open: openPreview, handleOpen, handleClose } = useModalDisclosure();
  const { ref: textRef, isOverflowed } = useTextOverflow(value);

  return (
    <Grid container size={12}>
      <Grid size={12}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <SolyticsTypography ref={textRef} ellipsis>
            {value}
          </SolyticsTypography>

          {isOverflowed && (
            <Typography
              component="span"
              onClick={handleOpen}
              sx={{
                ml: 0.2,
                color: 'primary.main',
                cursor: 'pointer',
                textDecoration: 'underline',
                flexShrink: 0,
              }}
            >
              Read More
            </Typography>
          )}
        </Box>
      </Grid>

      <Dialog open={openPreview} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Typography
            aria-live="polite"
            aria-atomic="true"
            sx={{
              wordWrap: 'break-word',
            }}
          >
            {attribute?.label}
          </Typography>
        </DialogTitle>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <DialogContent
            sx={{
              p: 0,
            }}
          >
            <Typography
              sx={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {value || '-'}
            </Typography>
          </DialogContent>
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

ViewTextFieldExtended.propTypes = {
  value: PropTypes.string,
  attribute: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
};

export default ViewTextFieldExtended;
